import { ThemeEditorDialog } from '@dotstorming/theme-editor';

import { getUserTheme, updateUserTheme } from '../../services/theme.service';

type UserThemeDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const UserThemeDialog = ({ open, onClose }: UserThemeDialogProps) => (
  <ThemeEditorDialog
    open={open}
    onClose={onClose}
    loadTheme={getUserTheme}
    saveTheme={updateUserTheme}
  />
);
